import { localStorage } from "globalthis/implementation";
import { createWebHistory, createRouter } from "vue-router";

import admin from '../src/views/admin'
import login from '../src/views/admin/login'
import resetPassword from '../src/views/admin/reset-password'
import home from '../src/views/pages'
import website from '../src/views/pages/website/'
// import adminPanel from '../src/views/pages/admin-panel/'
import userProfile from '../src/views/pages/admin-panel/user-profile'
import usersList from '../src/views/pages/admin-panel/users-management/users-list'
import manageUser from '../src/views/pages/admin-panel/users-management/manage-user'
import inboxManagement from '../src/views/pages/admin-panel/inbox-management/inbox-list'


import partnersList from '../src/views/pages/website/partners/partners-list'
import managePartner from '../src/views/pages/website/partners/manage-partner'

import aboutus from '../src/views/pages/website/aboutus/index.vue'

import valuesList from '../src/views/pages/website/aboutus/our-values/values-list'
import manageValue from '../src/views/pages/website/aboutus/our-values/manage-value'

import storiesList from '../src/views/pages/website/aboutus/our-stories/stories-list'
import manageStory from '../src/views/pages/website/aboutus/our-stories/manage-story'

import services from '../src/views/pages/website/services'
import servicesList from '../src/views/pages/website/services/services-list'
import manageService from '../src/views/pages/website/services/manage-service'

import coveragePhotosList from '../src/views/pages/website/services/photos-list'
import manageCoveragePhoto from '../src/views/pages/website/services/manage-photo'

import settings from '../src/views/pages/website/settings'
import pagesBannersList from '../src/views/pages/website/settings/pages-banners-list'
import managePagesBanner from '../src/views/pages/website/settings/manage-pages-banner'

import sectionsHeadersList from '../src/views/pages/website/settings/sections-headers-list'
import manageSectionsHeader from '../src/views/pages/website/settings/manage-sections-header'

import footer from '../src/views/pages/website/settings/footer'

import footerPhotos from '../src/views/pages/website/settings/footer/photos'
import footerPhotosList from '../src/views/pages/website/settings/footer/photos/footer-photos-list'
import manageFooterPhoto from '../src/views/pages/website/settings/footer/photos/manage-footer-photo'

import footerSocials from '../src/views/pages/website/settings/footer/socials'
import footerSocialsList from '../src/views/pages/website/settings/footer/socials/footer-socials-list'
import manageFooterSocial from '../src/views/pages/website/settings/footer/socials/manage-footer-social'

import footerContacts from '../src/views/pages/website/settings/footer/contacts'
import footerContactsList from '../src/views/pages/website/settings/footer/contacts/footer-contacts-list'
import manageFooterContact from '../src/views/pages/website/settings/footer/contacts/manage-footer-contact'

import footerBranches from '../src/views/pages/website/settings/footer/branches'
import footerBranchesList from '../src/views/pages/website/settings/footer/branches/footer-branches-list'
import manageFooterBranche from '../src/views/pages/website/settings/footer/branches/manage-footer-branche'

import footerPargraphs from '../src/views/pages/website/settings/footer/paragraphs'
import footerPargraphsList from '../src/views/pages/website/settings/footer/paragraphs/footer-paragraphs-list'
import manageFooterPargraph from '../src/views/pages/website/settings/footer/paragraphs/manage-footer-paragraph'

import Logos from '../src/views/pages/website/settings/logos'
import logosList from '../src/views/pages/website/settings/logos/logos-list'
import manageLogo from '../src/views/pages/website/settings/logos/manage-logo'

import SEOs from '../src/views/pages/website/settings/seo'
import SEOsList from '../src/views/pages/website/settings/seo/seo-list'
import manageSEO from '../src/views/pages/website/settings/seo/manage-seo'

import contactPage from '../src/views/pages/website/contact'
import contactPageArt from '../src/views/pages/website/contact/contact-art'

import contactPageFields from '../src/views/pages/website/contact/contact-fields'
import contactPageFieldsList from '../src/views/pages/website/contact/contact-fields/fields-list'
import manageContactPageField from '../src/views/pages/website/contact/contact-fields/manage-field'

import careersPage from '../src/views/pages/website/careers'
import careersPageArt from '../src/views/pages/website/careers/careers-art'
import careersPageFields from '../src/views/pages/website/careers/careers-fields'
import careersPageFieldsList from '../src/views/pages/website/careers/careers-fields/fields-list'
import manageCareersPageField from '../src/views/pages/website/careers/careers-fields/manage-field'
import careersPageDepartments from '../src/views/pages/website/careers/careers-departments'
import careersPageDepartmentsList from '../src/views/pages/website/careers/careers-departments/departments-list'
import manageCareersPageDepartment from '../src/views/pages/website/careers/careers-departments/manage-department'

import homePage from '../src/views/pages/website/home'
import homePageVideo from '../src/views/pages/website/home/home-video'

import homePageFacts from '../src/views/pages/website/home/home-facts'
import factsList from '../src/views/pages/website/home/home-facts/facts-list'
import manageFact from '../src/views/pages/website/home/home-facts/manage-fact'

import homePageTestimonials from '../src/views/pages/website/home/home-testimonials'
import testimonialsList from '../src/views/pages/website/home/home-testimonials/testimonials-list'
import manageTestimonial from '../src/views/pages/website/home/home-testimonials/manage-testimonial'

import homePageQuotes from '../src/views/pages/website/home/home-quotes'
import quotelsList from '../src/views/pages/website/home/home-quotes/quotes-list'
import manageQuote from '../src/views/pages/website/home/home-quotes/manage-quote'

// import pagesBannersList from '../src/views/pages/website/settings/pages-banners-list'
// import managePagesBanner from '../src/views/pages/website/settings/manage-pages-banner'

const routes = [
    {
        path: '/admin',
        component:admin,
        redirect:'/admin/login',
        meta: {
            auth: false
        },
        children:[
            {
                name:'login',
                path:'login',
                component:login, 
                meta: {
                    auth: false
                },
            },
            {
                path:'reset-password',
                name:'reset-password',
                component:resetPassword, 
                meta: {
                    auth: false
                },
            },
        ]
    },
    {
        path: '/',
        name: 'home',
        component: home,
        redirect:'/website/partners/partners-list',
        meta: {
            auth: true
        },
        children:[
            {   
                path:'website',
                name:'website',
                component:website,
                redirect:'/website/partners',
                children:[
                    
                    {
                        path:'home-page',
                        name:'home-page',
                        redirect:'/website/home-page/home-video',
                        component:homePage,
                        children:[
                            {
                                path:'home-video',
                                name:'home-video',
                                component:homePageVideo,
                                
                            },
                            {
                                path:'home-facts',
                                name:'home-facts',
                                component:homePageFacts,
                                redirect:'/website/home-page/home-facts/facts-list',
                                children:[
                                    {
                                        path:'facts-list',
                                        name:'facts-list',
                                        component:factsList, 
                                    },
                                    {
                                        path:'manage-fact/:id?',
                                        name:'manage-fact',
                                        component:manageFact, 
                                    },
                                ]
                            },
                            {
                                path:'home-testimonials',
                                name:'home-testimonials',
                                component:homePageTestimonials,
                                redirect:'/website/home-page/home-testimonials/testimonials-list',
                                children:[
                                    {
                                        path:'testimonials-list',
                                        name:'testimonials-list',
                                        component:testimonialsList, 
                                    },
                                    {
                                        path:'manage-testimonial/:id?',
                                        name:'manage-testimonial',
                                        component:manageTestimonial, 
                                    },
                                ]
                            },
                            {
                                path:'home-quotes',
                                name:'home-quotes',
                                component:homePageQuotes,
                                redirect:'/website/home-page/home-quotes/quotes-list',
                                children:[
                                    {
                                        path:'quotes-list',
                                        name:'quotes-list',
                                        component:quotelsList, 
                                    },
                                    {
                                        path:'manage-quote/:id?',
                                        name:'manage-quote',
                                        component:manageQuote, 
                                    },
                                ]
                            },
                           
                            
                        ]
                    },
                    {
                        path:'contact-page',
                        name:'contact-page',
                        redirect:'/website/contact-page/contact-art',
                        component:contactPage,
                        children:[
                            {
                                path:'contact-art',
                                name:'contact-art',
                                component:contactPageArt,
                                
                            },
                            {
                                path:'contact-fields',
                                name:'contact-fields',
                                component:contactPageFields,
                                redirect:'/website/contact-page/contact-fields/contact-fields-list',
                                children:[
                                    {
                                        path:'contact-fields-list',
                                        name:'contact-fields-list',
                                        component:contactPageFieldsList, 
                                    },
                                    {
                                        path:'contact-manage-field/:id?',
                                        name:'contact-manage-field',
                                        component:manageContactPageField, 
                                    },
                                ]
                            },
                            
                        ]
                    },
                    {
                        path:'careers-page',
                        name:'careers-page',
                        redirect:'/website/careers-page/careers-art',
                        component:careersPage,
                        
                        children:[
                            {
                                path:'careers-art',
                                name:'careers-art',
                                component:careersPageArt,
                                
                            },
                            {
                                path:'careers-fields',
                                name:'careers-fields',
                                component:careersPageFields,
                                redirect:'/website/careers-page/careers-fields/careers-fields-list',
                                children:[
                                    {
                                        path:'careers-fields-list',
                                        name:'careers-fields-list',
                                        component:careersPageFieldsList, 
                                    },
                                    {
                                        path:'careers-manage-field/:id?',
                                        name:'careers-manage-field',
                                        component:manageCareersPageField, 
                                    },
                                ]
                                
                            },
                            {
                                path:'careers-departments',
                                name:'careers-departments',
                                component:careersPageDepartments,
                                redirect:'/website/careers-page/careers-departments/departments-list',
                                children:[
                                    {
                                        path:'departments-list',
                                        name:'departments-list',
                                        component:careersPageDepartmentsList, 
                                    },
                                    {
                                        path:'manage-department/:id?',
                                        name:'manage-department',
                                        component:manageCareersPageDepartment, 
                                    },
                                ]
                                
                            },
                            
                            
                        ]
                    },
                    {
                        path:'partners',
                        name:'partners',
                        redirect:'/website/partners/partners-list',
                        children:[
                            {
                                path:'partners-list',
                                name:'partners-list',
                                component:partnersList, 
                            },
                            {
                                path:'manage-partner/:id?',
                                name:'manage-partner',
                                component:managePartner, 
                            },
                            
                        ]
                    },
                    {
                        path:'aboutus',
                        name:'aboutus',
                        template:aboutus,
                        redirect:'/website/aboutus/values/values-list',
                        children:[
                            {
                                path:'values',
                                name:'values',
                                redirect:'/website/aboutus/values/values-list',
                                children:[
                                    {
                                        path:'values-list',
                                        name:'values-list',
                                        component:valuesList, 
                                    },
                                    {
                                        path:'manage-value/:id?',
                                        name:'manage-value',
                                        component:manageValue, 
                                    },
                                ]
                            },
                            {
                                path:'stories',
                                name:'stories',
                                redirect:'/website/aboutus/stories/stories-list',
                                children:[
                                    {
                                        path:'stories-list',
                                        name:'stories-list',
                                        component:storiesList, 
                                    },
                                    {
                                        path:'manage-story/:id?',
                                        name:'manage-story',
                                        component:manageStory, 
                                    },
                                ]
                            },
                            
                            
                        ]
                    },
                    {
                        path:'services',
                        name:'services',
                        template:services,
                        redirect:'/website/services/services-list',
                        children:[
                            {
                                path:'services-list',
                                name:'services-list',
                                component:servicesList, 
                            },
                            {
                                path:'manage-service/:id?',
                                name:'manage-service',
                                component:manageService, 
                            },
                            {
                                path:'photos-list',
                                name:'photos-list',
                                component:coveragePhotosList, 
                            },
                            {
                                path:'manage-photo/:id?',
                                name:'manage-photo',
                                component:manageCoveragePhoto, 
                            },
                            
                        ]
                    },
                    {
                        path:'settings',
                        name:'settings',
                        template:settings,
                        redirect:'/website/settings/pages-banners-list',
                        children:[
                            {
                                path:'pages-banners-list',
                                name:'pages-banners-list',
                                component:pagesBannersList, 
                            },
                            {
                                path:'manage-pages-banner/:id?',
                                name:'manage-pages-banner',
                                component:managePagesBanner, 
                            },
                            {
                                path:'sections-headers-list',
                                name:'sections-headers-list',
                                component:sectionsHeadersList, 
                            },
                            {
                                path:'manage-sections-header/:id?',
                                name:'manage-sections-header',
                                component:manageSectionsHeader, 
                            },
                            {
                                path:'logos',
                                name:'logos',
                                component:Logos,
                                redirect:'/website/settings/logos/logos-list',
                                children:[
                                    {
                                        path:'logos-list',
                                        name:'logos-list',
                                        component:logosList, 
                                    },
                                    {
                                        path:'manage-logo/:id?',
                                        name:'manage-logo',
                                        component:manageLogo, 
                                    },
                                ] 
                            },
                            {
                                path:'seo',
                                name:'seo',
                                component:SEOs,
                                redirect:'/website/settings/seo/seo-list',
                                children:[
                                    {
                                        path:'seo-list',
                                        name:'seo-list',
                                        component:SEOsList, 
                                    },
                                    {
                                        path:'manage-seo/:id?',
                                        name:'manage-seo',
                                        component:manageSEO, 
                                    },
                                ] 
                            },
                            {
                                path:'footer',
                                name:'footer',
                                component:footer,
                                redirect:'/website/settings/footer/footer-photos/footer-photos-list',
                                children:[
                                    {
                                        path:'footer-photos',
                                        name:'footer-photos',
                                        component:footerPhotos,
                                        redirect:'/website/settings/footer/footer-photos/footer-photos-list',
                                        children:[
                                            {
                                                path:'footer-photos-list',
                                                name:'footer-photos-list',
                                                component:footerPhotosList, 
                                            },
                                            {
                                                path:'manage-footer-photo/:id?',
                                                name:'manage-footer-photo',
                                                component:manageFooterPhoto, 
                                            },
                                        ] 
                                    },
                                    {
                                        path:'footer-branches',
                                        name:'footer-branches',
                                        component:footerBranches,
                                        redirect:'/website/settings/footer/footer-branches/footer-branches-list',
                                        children:[
                                            {
                                                path:'footer-branches-list',
                                                name:'footer-branches-list',
                                                component:footerBranchesList, 
                                            },
                                            {
                                                path:'manage-footer-branche/:id?',
                                                name:'manage-footer-branche',
                                                component:manageFooterBranche, 
                                            },
                                        ] 
                                    },
                                    {
                                        path:'footer-socials',
                                        name:'footer-socials',
                                        component:footerSocials,
                                        redirect:'/website/settings/footer/footer-socials/footer-socials-list',
                                        children:[
                                            {
                                                path:'footer-socials-list',
                                                name:'footer-socials-list',
                                                component:footerSocialsList, 
                                            },
                                            {
                                                path:'manage-footer-social/:id?',
                                                name:'manage-footer-social',
                                                component:manageFooterSocial, 
                                            },
                                        ] 
                                    },
                                    {
                                        path:'footer-contacts',
                                        name:'footer-contacts',
                                        component:footerContacts,
                                        redirect:'/website/settings/footer/footer-contacts/footer-contacts-list',
                                        children:[
                                            {
                                                path:'footer-contacts-list',
                                                name:'footer-contacts-list',
                                                component:footerContactsList, 
                                            },
                                            {
                                                path:'manage-footer-contact/:id?',
                                                name:'manage-footer-contact',
                                                component:manageFooterContact, 
                                            },
                                        ] 
                                    },
                                    {
                                        path:'footer-paragraphs',
                                        name:'footer-paragraphs',
                                        component:footerPargraphs,
                                        redirect:'/website/settings/footer/footer-paragraphs/footer-paragraphs-list',
                                        children:[
                                            {
                                                path:'footer-paragraphs-list',
                                                name:'footer-paragraphs-list',
                                                component:footerPargraphsList, 
                                            },
                                            {
                                                path:'manage-footer-paragraph/:id?',
                                                name:'manage-footer-paragraph',
                                                component:manageFooterPargraph, 
                                            },
                                        ] 
                                    },
                                    
                                ] 
                            },
                        ]
                    },
                    
                ]
            },
            {   
                path:'/admin-panel',
                name:'admin-panel',
                // component:adminPanel,
                redirect:'/admin-panel/inbox-management',
                children:[
                    {
                        path:'user-profile',
                        name:'user-profile',
                        component:userProfile
                    },
                    {
                        path:'users',
                        name:'users',
                        redirect:'/admin-panel/users/users-list',
                        children:[
                            {
                                path:'users-list',
                                name:'users-list',
                                component:usersList
                            },
                            {
                                path:'manage-user/:id?',
                                name:'manage-user',
                                component:manageUser
                            }
                        ]
                    },
                    {
                        path:'inbox-management',
                        name:'inbox-management',
                        component:inboxManagement
                    }
                ]
                
            }
        ]
    },
    {
        path: "/:catchAll(.*)*",
        redirect: '/'
    }

]
const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory('/'),
    routes, // short for `routes: routes`
})
router.beforeEach((to, from, next) => {
    const isLoggedIn = localStorage.getItem('awsatLoggedIn') || false;
    console.log('isLoggedIn => ' + isLoggedIn);
    if (to.matched.some(record => record.meta.auth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isLoggedIn) {
            next({ name: 'login' })
        } else {
            next() // go to wherever I'm going
        }
    } else {
        if (to.path == '/admin/login' && isLoggedIn) {
            next('/')
        }
        next() // does not require auth, make sure to always call next()!
    }


});
export default router;